// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodepenCircleFilledSvg from "@ant-design/icons-svg/es/asn/CodepenCircleFilled";
import AntdIcon from '../components/AntdIcon';

var CodepenCircleFilled = function CodepenCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodepenCircleFilledSvg
  }));
};

CodepenCircleFilled.displayName = 'CodepenCircleFilled';
export default React.forwardRef(CodepenCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CodepenCircleFilled.js
// module id = 825
// module chunks = 0